import React from "react"
import Avatar from "components/common/Avatar"
import Button from "components/common/Button"
import "./index.scss"

const Comment = ({ photo, comment, author, dateCreated, handleEdit }) => (
  <div className="comment-wrapper">
    <Avatar size="24" src={photo} name={author} />
    <div className="comment-item">
      <p className="author">{author}</p>
      {/* p for view, textarea for edit/add */}
      <p className="comment">{comment}</p>
      {/* <textarea className="input" rows={2} /> */}
    </div>
    <div className="meta-actions">
      <div className="comment-actions">
        <Button onClick={handleEdit} size="paddingless" ghost label="Edit" />
      </div>
      <div className="details">
        <span className="timestamp">{dateCreated}</span>
      </div>
    </div>
  </div>
)

export default Comment
